import { parse, stringify } from 'flatted';
import { unwrap, wrap } from '../object-wrapper';
import { isDevEnv } from './host-manager';
import { getFromStore, removeFromStore, setOnStore } from './store-manager';

function setCache(slug, context, object, options = null) {
  if (isUpdated(slug, context, object)) {
    return false;
  }

  const key = getKey(slug, context);

  if (object == null) {
    removeFromStore(key);
  } else {
    setOnStore(key, stringify(wrap(object, options)));
  }

  return true;
}

function getCache(slug, context) {
  const key = getKey(slug, context);
  const string = getFromStore(key);

  if (string != null) {
    try {
      return unwrap(parse(string));
    } catch (error) {
      removeFromStore(key);
    }
  }

  return null;
}

function isUpdated(slug, context, object) {
  return stringify(object) === getCache(slug, context);
}

function getKey(slug, context) {
  return `${isDevEnv ? 'dev_' : ''}${slug == null ? '' : `${slug}_`}${context}`;
}

export { getCache, setCache };
